(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
    key: "AIzaSyCpomcsaQw2x85J1wB02y32WpHEArejW3c",
});


let center;
if (($('.dealer-map #map')).length) {
    center = { lat: parseFloat(citymap[0].lat_long.split(', ')[0]), lng: parseFloat(citymap[0].lat_long.split(', ')[1]) };
}

let mapCenter = center;
let map;
let map_mobile;

let counterMap = 0;
let page = 0;

let filter_country = 'All';
let filter_input = '';

let markersD = {};
let markersM = {};

let currentInfoWindow_D = null;
let currentInfoWindow_M = null;

$(document).on('shopify:section:load', function() {

    if ($('.partner-with-us').length) {
        $('.partner-with-us .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.blog-slider').length) {
        $('.blog-slider .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.find-dealer').length) {
        $('.find-dealer .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    $('.paginate.custom').each(function() {
        initializePagination($(this));
    });

    let headerH = $('.header').height();
    $('.dealer-map .map-wrapper').css('height', `calc(100% - ${headerH}px)`);
    
    if (($('.dealer-map #map')).length) {
        if (citymap.length > 0) {
            for (const city in citymap) {
    
                counterMap++;
                page = Math.floor((counterMap - 1) / 5) + 1;
    
                let append = '<div class="location" data-page="'+page+'" data-lat="'+parseFloat(citymap[city].lat_long.split(', ')[0])+'" data-lng="'+parseFloat(citymap[city].lat_long.split(', ')[1])+'" data-country="'+citymap[city].country+'" data-type="'+citymap[city].type+'" data-address="'+citymap[city].address+'" data-contact="'+citymap[city].contact+'" data-title="'+citymap[city].title+'">'+
                                '<img class="location-image" src="'+citymap[city].image+'">'+
                                '<p class="location-name">'+counterMap+'. '+citymap[city].title+'</p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016"><span><span>Adress:</span> '+citymap[city].address+'</span></p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017"><span><span>Contact:</span> '+citymap[city].contact+'</span></p>'+
                             '</div>';
    
                $('.locations').append(append);
            }
    
            locPaginate();
        }

        let defaultMarker = {
            path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
            fillColor: "#161616",
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 2,
            anchor: { x: 12, y: 24 },
        };
    
        async function initMap() {
            const { Map } = await google.maps.importLibrary("maps");
        
            map = new Map(document.getElementById("map"), {
                center: mapCenter,
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
        
            map_mobile = new Map(document.getElementById("map-mobile"), {
                center: mapCenter,
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
    
            for (const city in citymap) {
                let center = {
                    lat: parseFloat(citymap[city].lat_long.split(', ')[0]),
                    lng: parseFloat(citymap[city].lat_long.split(', ')[1])
                };

                if (citymap[city].store_type == 'Shopping') {
                    defaultMarker = 'https://cdn.shopify.com/s/files/1/0605/5188/9131/files/shopping_5015576d-5133-4e98-a92a-55aa02022bac.png?v=1742361006'
                }
                else if (citymap[city].store_type == 'Test Ride') {
                    defaultMarker = 'https://cdn.shopify.com/s/files/1/0605/5188/9131/files/test_ride_bdc8b3e6-003d-4386-9294-cca455a5de97.png?v=1742361006'
                }
                else if (citymap[city].store_type == 'Repair') {
                    defaultMarker = 'https://cdn.shopify.com/s/files/1/0605/5188/9131/files/repair_f88ae880-5585-4bf9-80ab-fcedfa652d60.png?v=1742361006'
                }
                else {
                    defaultMarker = {
                        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
                        fillColor: "#161616",
                        fillOpacity: 1,
                        strokeWeight: 0,
                        rotation: 0,
                        scale: 2,
                        anchor: { x: 12, y: 24 },
                    }
                }
    
                const markerD = new google.maps.Marker({
                    position: center,
                    map: map,
                    icon: defaultMarker
                });
        
                const markerM = new google.maps.Marker({
                    position: center,
                    map: map_mobile,
                    icon: defaultMarker
                });

                const contentString = `
                    <div class="map-info">
                        <div class="map-image">
                            <img src="${citymap[city].image}">
                        </div>
                        <div class="map-more">
                            <p class="body-lg mu-semibold f-black">${citymap[city].title}</p>
                            <p class="map-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016"><span><span>Adress:</span> ${citymap[city].address}</span></p>
                            <p class="map-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017"><span><span>Contact:</span> ${citymap[city].contact}</span></p>
                        </div>
                    </div>
                `;

                markerD.infowindow = new google.maps.InfoWindow({
                    content: contentString
                });      
                markerD.addListener("click", () => {
                    if (currentInfoWindow_D)
                        currentInfoWindow_D.close();
    

                    markerD.infowindow.open(map, markerD);
                    currentInfoWindow_D = markerD.infowindow;
                });

                /* markerM.infowindow = new google.maps.InfoWindow({
                    content: contentString
                });      
                markerM.addListener("click", () => {
                    if (currentInfoWindow_D)
                        currentInfoWindow_M.close();
    

                    markerM.infowindow.open(map_mobile, markerM);
                    currentInfoWindow_M = markerM.infowindow;
                }); */

                markersD[`${center.lat},${center.lng}`] = markerD;
                //markersM[`${center.lat},${center.lng}`] = markerM;
            }
        }
    
        initMap();
    }

    find_dealer();
    image_text();

});

$(document).ready(function() {

    if ($('.partner-with-us').length) {
        $('.partner-with-us .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.blog-slider').length) {
        $('.blog-slider .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: false,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3
                    }
                }
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    if ($('.find-dealer').length) {
        $('.find-dealer .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    $('.paginate.custom').each(function() {
        initializePagination($(this));
    });

    let headerH = $('.header').height();
    $('.dealer-map .map-wrapper').css('height', `calc(100% - ${headerH}px)`);
    
    if (($('.dealer-map #map')).length) {
        if (citymap.length > 0) {
            for (const city in citymap) {
    
                counterMap++;
                page = Math.floor((counterMap - 1) / 5) + 1;
    
                let append = '<div class="location" data-page="'+page+'" data-lat="'+parseFloat(citymap[city].lat_long.split(', ')[0])+'" data-lng="'+parseFloat(citymap[city].lat_long.split(', ')[1])+'" data-country="'+citymap[city].country+'" data-type="'+citymap[city].type+'" data-address="'+citymap[city].address+'" data-contact="'+citymap[city].contact+'" data-title="'+citymap[city].title+'">'+
                                '<img class="location-image" src="'+citymap[city].image+'">'+
                                '<p class="location-name">'+counterMap+'. '+citymap[city].title+'</p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016"><span><span>Adress:</span> '+citymap[city].address+'</span></p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017"><span><span>Contact:</span> '+citymap[city].contact+'</span></p>'+
                             '</div>';
    
                $('.locations').append(append);
            }
    
            locPaginate();
        }

        let defaultMarker = {
            path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
            fillColor: "#161616",
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 2,
            anchor: { x: 12, y: 24 },
        };
    
        async function initMap() {
            const { Map } = await google.maps.importLibrary("maps");
        
            map = new Map(document.getElementById("map"), {
                center: mapCenter,
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
        
            map_mobile = new Map(document.getElementById("map-mobile"), {
                center: mapCenter,
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
    
            for (const city in citymap) {
                let center = {
                    lat: parseFloat(citymap[city].lat_long.split(', ')[0]),
                    lng: parseFloat(citymap[city].lat_long.split(', ')[1])
                };

                if (citymap[city].store_type == 'Shopping') {
                    defaultMarker = 'https://cdn.shopify.com/s/files/1/0605/5188/9131/files/shopping_5015576d-5133-4e98-a92a-55aa02022bac.png?v=1742361006'
                }
                else if (citymap[city].store_type == 'Test Ride') {
                    defaultMarker = 'https://cdn.shopify.com/s/files/1/0605/5188/9131/files/test_ride_bdc8b3e6-003d-4386-9294-cca455a5de97.png?v=1742361006'
                }
                else if (citymap[city].store_type == 'Repair') {
                    defaultMarker = 'https://cdn.shopify.com/s/files/1/0605/5188/9131/files/repair_f88ae880-5585-4bf9-80ab-fcedfa652d60.png?v=1742361006'
                }
                else {
                    defaultMarker = {
                        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
                        fillColor: "#161616",
                        fillOpacity: 1,
                        strokeWeight: 0,
                        rotation: 0,
                        scale: 2,
                        anchor: { x: 12, y: 24 },
                    }
                }
    
                const markerD = new google.maps.Marker({
                    position: center,
                    map: map,
                    icon: defaultMarker
                });
        
                const markerM = new google.maps.Marker({
                    position: center,
                    map: map_mobile,
                    icon: defaultMarker
                });

                const contentString = `
                    <div class="map-info">
                        <div class="map-image">
                            <img src="${citymap[city].image}">
                        </div>
                        <div class="map-more">
                            <p class="body-lg mu-semibold f-black">${citymap[city].title}</p>
                            <p class="map-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016"><span><span>Adress:</span> ${citymap[city].address}</span></p>
                            <p class="map-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017"><span><span>Contact:</span> ${citymap[city].contact}</span></p>
                        </div>
                    </div>
                `;

                markerD.infowindow = new google.maps.InfoWindow({
                    content: contentString
                });      
                markerD.addListener("click", () => {
                    if (currentInfoWindow_D)
                        currentInfoWindow_D.close();
    

                    markerD.infowindow.open(map, markerD);
                    currentInfoWindow_D = markerD.infowindow;
                });

                /* markerM.infowindow = new google.maps.InfoWindow({
                    content: contentString
                });      
                markerM.addListener("click", () => {
                    if (currentInfoWindow_D)
                        currentInfoWindow_M.close();
    

                    markerM.infowindow.open(map_mobile, markerM);
                    currentInfoWindow_M = markerM.infowindow;
                }); */

                markersD[`${center.lat},${center.lng}`] = markerD;
                //markersM[`${center.lat},${center.lng}`] = markerM;
            }
        }
    
        initMap();
    }

    find_dealer();
    image_text();

});

$(window).scroll(function() {
    find_dealer();
    image_text();
});

$(window).resize(function() {
    let headerH = $('.header').height();
    $('.dealer-map .map-wrapper').css('height', `calc(100% - ${headerH}px)`);
});

$(document).on('click', '.location', function() {;
    const lat = $(this).data('lat');
    const lng = $(this).data('lng');
    const markerKey = `${lat},${lng}`;

    map.setZoom(15);
    map.panTo({ lat, lng });
    map_mobile.setZoom(15);
    map_mobile.panTo({ lat, lng });

    if (window.innerWidth < 1280) {
        /* if (markersM[markerKey]) {
            google.maps.event.trigger(markersM[markerKey], 'click');
        } */

        let title = $(this).data('title');
        let address = $(this).data('address');
        let contact = $(this).data('contact');

        $('.map-wrapper .map-title').html(title);
        $('.map-wrapper .location-name').html(title);
        $('.map-wrapper .data.address').html(address);
        $('.map-wrapper .data.contact').html(contact);

        $('.map-wrapper').css('display', 'flex');

        $('body').css('overflow-y', 'hidden');
    }
    else {
        if (markersD[markerKey]) {
            google.maps.event.trigger(markersD[markerKey], 'click');
        }
    }
});

$('.map-wrapper .map-header').on('click', function() {
    $('.map-wrapper').hide();
    $('body').css('overflow-y', 'visible');
});

$('select[name="retail-country"]').on('change', function() {
    filter_country = $(this).val();

    filterLocation(filter_country, filter_input);
});
$('.filter-input .search-btn').on('click', function() {
    filter_input = $('input[name="search-address"]').val();

    filterLocation(filter_country, filter_input);
})
$('.filter-input input').on('keyup', function() {
    filter_input = $('input[name="search-address"]').val();

    filterLocation(filter_country, filter_input);
})

function filterLocation(country, location) {

    let show = citymap;

    if (country.toLowerCase() !== 'all') {
        show = show.filter(x => 
            x.country.toLowerCase().indexOf(country.toLowerCase()) >= 0
        );
    }
    if (location.toLowerCase() !== '') {
        show = show.filter(x => 
            x.address.toLowerCase().indexOf(location.toLowerCase()) >= 0 || 
            x.title.toLowerCase().indexOf(location.toLowerCase()) >= 0
        );
    }

    if (show.length > 0) {
        $('.locations').html('');
        counterMap = 0;
        
        for (let city in show) {
            counterMap ++;
            page = Math.floor((counterMap - 1) / 5) + 1;
            let append = '<div class="location" data-page="'+page+'" data-lat="'+parseFloat(show[city].lat_long.split(', ')[0])+'" data-lng="'+parseFloat(show[city].lat_long.split(', ')[1])+'" data-country="'+show[city].country+'" data-type="'+show[city].type+'" data-address="'+show[city].address+'" data-contact="'+show[city].contact+'" data-title="'+show[city].title+'">'+
                                '<img class="location-image" src="'+show[city].image+'">'+
                                '<p class="location-name">'+counterMap+'. '+show[city].title+'</p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016"><span><span>Adress:</span> '+show[city].address+'</span></p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017"><span><span>Contact:</span> '+show[city].contact+'</span></p>'+
                            '</div>';

            $('.locations').append(append);
        }

        locPaginate();

        map.setZoom(15);
        map.panTo({
            lat : parseFloat(show[0].lat_long.split(', ')[0]),
            lng : parseFloat(show[0].lat_long.split(', ')[1])
        });
    }
    else {
        $('.locations').html('<div class="no-found">No store found.</div>');
    }
}

function locPaginate() {
    if (window.innerWidth < 1280) {
        if (counterMap > 5) {
            const itemsPerPage = 5;
            const totalItems = counterMap;
            const totalPages = Math.floor(totalItems / itemsPerPage);
            const remainder = totalItems % itemsPerPage;
    
            let pageTotal = totalPages;
            if (remainder !== 0) {
                pageTotal += 1;
            }
    
            const $pagination = $('<div class="paginate custom d-lg-none d-md-flex d-sm-flex" data-total="' + pageTotal + '"></div>');
    
            const $leftArrow = $('<a class="page disable" href="javascript:void(0)"><i class="fa-solid fa-chevron-left"></i></a>');
            $pagination.append($leftArrow);
    
            for (let i = 1; i <= pageTotal; i++) {
                const $pageLink = $('<a class="page' + (i === 1 ? ' active' : '') + '" href="javascript:void(0)" data-i="' + i + '">' + i + '</a>');
                $pagination.append($pageLink);
            }
    
            const $rightArrow = $('<a class="page" href="javascript:void(0)" data-i="' + (pageTotal) + '"><i class="fa-solid fa-chevron-right"></i></a>');
            $pagination.append($rightArrow);
    
            $('.dealer-map .locations').append($pagination);
            initializePagination($($pagination));
        }
    }
}

function updatePagination($pagination, currentPage, totalPages) {

    $pagination.empty();

    $pagination.append(`
        <a class="page ${currentPage === 1 ? 'disable' : ''}" href="javascript:void(0)" data-action="prev">
            <i class="fa-solid fa-chevron-left"></i>
        </a>
    `);

    let pageNumbers = '';

    if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers += `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`;
        }
    } else {
        const maxPagesToShow = 2;
        const startPage = Math.max(2, currentPage - maxPagesToShow);
        const endPage = Math.min(totalPages - 1, currentPage + maxPagesToShow);

        pageNumbers += `<a class="page ${currentPage === 1 ? 'active' : ''}" href="javascript:void(0)" data-i="1">1</a>`;

        if (startPage > 2) {
            pageNumbers += '<a class="page disable" href="javascript:void(0)">…</a>';
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers += `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`;
        }

        if (endPage < totalPages - 1) {
            pageNumbers += '<a class="page disable" href="javascript:void(0)">…</a>';
        }

        pageNumbers += `<a class="page ${currentPage === totalPages ? 'active' : ''}" href="javascript:void(0)" data-i="${totalPages}">${totalPages}</a>`;
    }

    $pagination.append(pageNumbers);

    $pagination.append(`
        <a class="page ${currentPage === totalPages ? 'disable' : ''}" href="javascript:void(0)" data-action="next">
            <i class="fa-solid fa-chevron-right"></i>
        </a>
    `);

    const $customRow = $pagination.parent();
    $customRow.find('[data-page]').hide();
    $customRow.find(`[data-page="${currentPage}"]`).show();
}

function initializePagination($pagination) {
    const totalPages = $pagination.data('total');
    let currentPage = 1;

    updatePagination($pagination, currentPage, totalPages);

    $pagination.on('click', '.page[data-i]', function() {
        const newPage = $(this).data('i');
        if (newPage && newPage !== currentPage) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage = newPage;
            updatePagination($pagination, currentPage, totalPages);
        }
    });

    $pagination.on('click', '[data-action="prev"]', function() {
        if (currentPage > 1) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage--;
            updatePagination($pagination, currentPage, totalPages);
        }
    });

    $pagination.on('click', '[data-action="next"]', function() {
        if (currentPage < totalPages) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage++;
            updatePagination($pagination, currentPage, totalPages);
        }
    });
}

function find_dealer() {
    if ($('.find-dealer').length) {
        $('.find-dealer').each(function() {
            if (wSize >= 1280) {
                let el = $(this);
        
                if (visiblePercent(el) > 50) {
                    el.find('.col-4:nth-child(1) .step').css({
                        'top': '0',
                        'opacity': '1'
                    });
                    setTimeout(() => {
                        el.find('.col-4:nth-child(2) .step').css({
                            'top': '0',
                            'opacity': '1'
                        });
                    }, 100);
                    setTimeout(() => {
                        el.find('.col-4:nth-child(3) .step').css({
                            'top': '0',
                            'opacity': '1'
                        });
                    }, 100);
                }
            }
        });    
    }
}

function image_text() {
    if ($('.image-text').length) {
        $('.image-text').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
                el.find('img').addClass('active');
            }
        });    
    }
}

let heard_on = [];

$('.dealer-form .checkboxes input').on('change', function() {
    const value = $(this).val();

    if ($(this).is(':checked')) {
        if (!heard_on.includes(value)) {
            heard_on.push(value);
        }
    } else {
        heard_on = heard_on.filter(item => item !== value);
    }

    $('input[name="contact[heard_on]"]').val(heard_on.join(', '));

    console.log(heard_on);
});